import React, { useState, useEffect } from 'react';
import { getAllUserPermissions } from '../utils/permissions';

const PermissionDebug: React.FC = () => {
  const [permissions, setPermissions] = useState<{ permissions: string[]; roles: string[] } | null>(null);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loadPermissions = async () => {
      try {
        // Check if user is logged in first
        const accessToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
        if (!accessToken) {
          setIsLoggedIn(false);
          setLoading(false);
          return;
        }
        
        setIsLoggedIn(true);
        const userPermissions = await getAllUserPermissions();
        setPermissions(userPermissions);
      } catch (error) {
        console.error('Error loading permissions:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPermissions();
  }, []);

  if (loading) {
    return <div>Lade Berechtigungen...</div>;
  }

  if (!isLoggedIn) {
    return null; // Don't show anything if not logged in
  }

  if (!permissions) {
    return (
      <div style={{ 
        position: 'fixed', 
        top: 10, 
        right: 10, 
        background: '#fff3cd', 
        border: '1px solid #ffeaa7', 
        borderRadius: 8, 
        padding: 16, 
        zIndex: 9999,
        maxWidth: 300,
        fontSize: 12
      }}>
        <h4 style={{ margin: '0 0 8px 0', color: '#856404' }}>Debug: Berechtigungen</h4>
        <div style={{ color: '#856404' }}>Keine Berechtigungen gefunden</div>
      </div>
    );
  }

  return (
    <div style={{ 
      position: 'fixed', 
      top: 10, 
      right: 10, 
      background: '#f0f0f0', 
      border: '1px solid #ccc', 
      borderRadius: 8, 
      padding: 16, 
      zIndex: 9999,
      maxWidth: 300,
      fontSize: 12
    }}>
      <h4 style={{ margin: '0 0 8px 0', color: '#333' }}>Debug: Benutzerberechtigungen</h4>
      <div>
        <strong>Berechtigungen:</strong>
        <ul style={{ margin: '4px 0', paddingLeft: 16 }}>
          {permissions.permissions.map((permission, index) => (
            <li key={index} style={{ color: permission === 'asm-login-permission' ? 'green' : 'black' }}>
              {permission}
            </li>
          ))}
        </ul>
      </div>
      <div>
        <strong>Rollen:</strong>
        <ul style={{ margin: '4px 0', paddingLeft: 16 }}>
          {permissions.roles.map((role, index) => (
            <li key={index}>{role}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PermissionDebug;
